import { render } from "./ManageItem.vue?vue&type=template&id=73f654a8"
import script from "./ManageItem.vue?vue&type=script&lang=js"
export * from "./ManageItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__